import { IBusBaoCaoDiemDanhRequest, IBusTuyenDuongSelectRequest } from '../../../models/request/bus/busBaoCaoDiemDanhRequest';
import { BusBaoCaoDiemDanhItemResponse } from '../../../models/response/bus/BusBaoCaoDiemDanhItemResponse';
import { BusTuyenDuongItemResponse } from '../../../models/response/bus/bus_tuyenduong';

export enum eBusBaoCaoDiemDanhActionTypeIds {
	LOAD_START = "BUS_BAOCAO_DIEMDANH_LOAD_START",
	LOAD_SUCCESS = "BUS_BAOCAO_DIEMDANH_LOAD_SUCCESS",
	LOAD_ERROR = "BUS_BAOCAO_DIEMDANH_LOAD_ERROR",

	LOAD_TUYENDUONG_START = "BUS_BAOCAO_DIEMDANH_LOAD_TUYENDUONG_START",
	LOAD_TUYENDUONG_SUCCESS = "BUS_BAOCAO_DIEMDANH_LOAD_TUYENDUONG_SUCCESS",
	LOAD_TUYENDUONG_ERROR = "BUS_BAOCAO_DIEMDANH_LOAD_TUYENDUONG_ERROR"
}

export interface IBusBaoCaoDiemDanhLoadStart {
	type: eBusBaoCaoDiemDanhActionTypeIds.LOAD_START,
	payload: IBusBaoCaoDiemDanhRequest
}
export interface IBusBaoCaoDiemDanhLoadSuccess {
	type: eBusBaoCaoDiemDanhActionTypeIds.LOAD_SUCCESS,
	payload: BusBaoCaoDiemDanhItemResponse[]
}
export interface IBusBaoCaoDiemDanhLoadErr {
	type: eBusBaoCaoDiemDanhActionTypeIds.LOAD_ERROR,
	payload: string
}
export interface IBusBaoCaoDiemDanhLoadTuyenDuongStart {
	type: eBusBaoCaoDiemDanhActionTypeIds.LOAD_TUYENDUONG_START,
	payload: IBusTuyenDuongSelectRequest
}
export interface IBusBaoCaoDiemDanhLoadTuyenDuongSuccess {
	type: eBusBaoCaoDiemDanhActionTypeIds.LOAD_TUYENDUONG_SUCCESS,
	payload: BusTuyenDuongItemResponse[]
}
export interface IBusBaoCaoDiemDanhLoadTuyenDuongErr {
	type: eBusBaoCaoDiemDanhActionTypeIds.LOAD_TUYENDUONG_ERROR,
	payload: string
}

export type IBusBaoCaoDiemDanhActionTypes = IBusBaoCaoDiemDanhLoadStart | IBusBaoCaoDiemDanhLoadSuccess | IBusBaoCaoDiemDanhLoadErr |
	IBusBaoCaoDiemDanhLoadTuyenDuongStart | IBusBaoCaoDiemDanhLoadTuyenDuongSuccess | IBusBaoCaoDiemDanhLoadTuyenDuongErr
